<template>
  <div class="partner-school-type">
    <h3 v-if="heading"
        class="partner-school-type__heading">
      <font-awesome-icon
        icon="map-marker-alt"
        aria-hidden="true"
        class="partner-school-type__icon"
        :style="{ color: '#' + color }"></font-awesome-icon>
      {{ heading }}
    </h3>
    <!--eslint-disable vue/no-v-html-->
    <div class="partner-school-type__content fancy-bullets"
         v-html="content"></div>
    <!--eslint-enable vue/no-v-html-->
  </div>
</template>

<script>
export default {
  name: "PartnerType",

  props: {
    heading: {
      type: String,
      default: null,
    },

    content: {
      type: String,
      default: null,
    },

    color: {
      type: String,
      default: "#000",
    },
  },
};
</script>
